module.exports = __webpack_public_path__ + "media/images/lb/763-706d1d16a78a54d322b3d4972843e40f.svg";